import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";

import {Text, View} from "@khanacademy/wonder-blocks-core";
import {font, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

export const NewRegistrationHeroFigure = () => (
    <HeroFigure
        header={t`Khan Academy boosts scores!`}
        subheader={t`Learn with millions of people worldwide by exploring videos, tackling practice problems and getting AI-powered support.`}
        imageUrl={staticUrl("/images/lohp/boost-scores.png")}
    />
);

type Props = {
    header: string;
    subheader: string;
    imageUrl: string;
};

/**
 * Hero figure for the LOHP new registration flow.
 *
 * Don't use this component directly in a page. Wrap it in a component with
 * specific configuration, similar to NewRegistrationHeroFigure.
 */
const HeroFigure = ({header, subheader, imageUrl}: Props) => {
    return (
        <View style={styles.container}>
            <View style={styles.text}>
                <Text style={styles.heading} tag="h1">
                    {header}
                </Text>
                <Body style={styles.body}>{subheader}</Body>
            </View>
            <img
                src={staticUrl(imageUrl)}
                alt=""
                className={css(styles.image)}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        width: "100%",
        maxWidth: 616,
        display: "flex",
        alignItems: "center",
        gap: spacing.xxLarge_48,
    },
    text: {
        gap: spacing.medium_16,
    },
    heading: {
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
        fontWeight: 600,
        fontSize: 40,
        lineHeight: font.lineHeight.xxLarge,
    },
    body: {
        fontSize: font.size.large,
        lineHeight: font.lineHeight.xLarge,
    },
    image: {
        width: "100%",
        [mediaQueries.smOrSmaller]: {
            display: "none",
        },
    },
});
